import React, { useEffect, useState } from "react";
import { adminAxios } from "../api";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { Button } from "../../components/ui/button";
import CallusForm from "../components/CallusForm";

const LABELS = {
  urgency: "Top Urgency Bar", hero: "Hero Section", video: "Video Section",
  financial: "Financial Problems", about: "About / Astrologer", whatYouGet: "What You Get",
  trust: "Trust Badges", success: "Success Stories (Shorts)", faq: "FAQ",
  countdown: "Urgency / Countdown",
  showcase: "Certified & Energised",
  footer: "Footer / Contact", seo: "SEO Metadata",
  callus: "Call Us Popup",
};

const CmsAdmin = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const data = (await adminAxios.get("/cms")).data;
      setSections(data);
      if (!active && data.length) selectSection(data[0]);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const selectSection = (s) => { setActive(s.section); setText(JSON.stringify(s.data, null, 2)); setErr(""); };

  const save = async () => {
    let parsed;
    try { parsed = JSON.parse(text); setErr(""); } catch (e) { setErr("Invalid JSON: " + e.message); return; }
    setSaving(true);
    try {
      await adminAxios.put(`/cms/${active}`, { section: active, data: parsed, published: true });
      toast.success("Content updated — live on website");
      load();
    } catch (e) { toast.error("Save failed"); } finally { setSaving(false); }
  };

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-slate-400 animate-spin" /></div>;

  return (
    <div>
      <h1 className="text-2xl font-semibold text-slate-900 mb-1">Website Content</h1>
      <p className="text-slate-500 mb-6">Edit the content shown on the public website. Changes go live immediately.</p>
      <div className="grid grid-cols-12 gap-5">
        <div className="col-span-12 md:col-span-3 space-y-1">
          {sections.map((s) => (
            <button key={s.section} onClick={() => selectSection(s)} className={`w-full text-left px-3 py-2.5 rounded-lg text-sm font-medium ${active === s.section ? "bg-slate-900 text-white" : "bg-white border border-slate-200 hover:bg-slate-50 text-slate-700"}`}>
              {LABELS[s.section] || s.section}
            </button>
          ))}
        </div>
        <div className="col-span-12 md:col-span-9">
          {active === "callus" ? (
            <CallusForm />
          ) : (
          <div className="bg-white rounded-xl border border-slate-200 p-5">
            <div className="flex items-center justify-between mb-3">
              <h2 className="font-semibold text-slate-800">{LABELS[active] || active}</h2>
              <Button onClick={save} disabled={saving} className="bg-slate-900 hover:bg-slate-800">{saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />} Save &amp; Publish</Button>
            </div>
            {err && <div className="mb-2 text-sm text-red-600 bg-red-50 rounded px-3 py-2">{err}</div>}
            <textarea value={text} onChange={(e) => setText(e.target.value)} spellCheck={false}
              className="w-full h-[60vh] font-mono text-xs border border-slate-200 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-slate-400 bg-slate-50" />
            <p className="text-xs text-slate-400 mt-2">Edit the fields inside the braces. Keep the structure valid (JSON). Text values go inside the quotes.</p>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CmsAdmin;
